<template>
    <div class="partnership-page">
        <div class="banner link">
            <div class="mask">
                <img src="@/assets/images/sustainable/partnership/banner.png" alt="善意美好banner图片" />
            </div>
            <div class="content">
                <div class="wrap">
                    <h1>善意美好</h1>
                    <h3><span>共创美好生活</span></h3>
                    <p class="desc">
                        顺丰认为，企业在不断壮大、创造效益的同时，应该更好地服务社会。因此，顺丰坚持用实际行动，向社会传递善意与爱心，并在 2012
                        年发起成立顺丰公益基金会.
                    </p>
                </div>
            </div>
        </div>
        <div class="main-content">
            <h3>2023年关键数据</h3>
            <ul class="data-list text-left">
                <li class="data-item">
                    <div class="title"><span>2,700+</span><sub>个</sub></div>
                    <div class="remark">助力农产品产销服务网络覆盖全国县区级城市</div>
                </li>
                <li class="data-item">
                    <div class="title"><span>458</span><sub>万吨</sub></div>
                    <div class="remark">特色农产品包裹运送量</div>
                </li>
                <li class="data-item">
                    <div class="title"><span>1.06</span><sub>亿元</sub></div>
                    <div class="remark">顺丰公益基金会全年公益总支出</div>
                </li>
            </ul>
            <ul class="data-list text-left">
                <li class="data-item">
                    <div class="title"><span>38,067</span><sub>人</sub></div>
                    <div class="remark">累计资助困境学生</div>
                </li>
                <li class="data-item">
                    <div class="title"><span>21,379</span><sub>人</sub></div>
                    <div class="remark">累计救助孤贫患儿</div>
                </li>
                <li class="data-item">
                    <div class="title"><span>34,948</span><sub>小时</sub></div>
                    <div class="remark">志愿服务总时长</div>
                </li>
            </ul>
            <ul class="content-list">
                <li class="item item-help">
                    <h3>教育公益</h3>
                    <div class="card">
                        <div class="card-header link">
                            <div class="mask"></div>
                            <div class="detail-wrap">
                                <!-- <div>累计资助贫困中学生 <span>18,078</span> 名</div> -->
                                <div class="desc">
                                    顺丰莲花助学项目启动于2012年，旨在建立人与人之间更好的连结，帮助困境学生顺利完成学业，成长为具有优秀品格，能够适应社会发展，并愿意反哺社会的美好青年。<br />2023年，顺丰莲花助学项目在资助学生13,718人，共计发放奖助学金3,119万元。截止2023年底，项目累计发放奖助学金2.28亿元，累计资助困境学生38,067人。
                                </div>
                            </div>
                        </div>
                        <div class="card-body link">
                            <img src="@/assets/images/sustainable/partnership/help-chart.jpg" alt="爱心助学" />
                        </div>
                    </div>
                </li>
                <li class="item">
                    <h3>医疗救助</h3>
                    <div class="link">
                        <div class="mask"><img src="@/assets/images/sustainable/partnership/sf-item-01.png" alt="顺丰暖心" /></div>
                        <div class="detail-wrap">
                            <p class="desc">
                                顺丰暖心项目启动于2014年，项目包含儿童先心病救助、儿童血液病和恶性肿瘤救助、孤儿养护三大救助模块，同时在各救助模块融合人文关怀行动，形成多个子项目并行的儿童医疗救助项目矩阵，为孤贫儿童提供及时高效的医疗救助和人文关怀服务。
                                <br />截至2023年底，顺丰暖心项目累计投入约4.33亿元，救助困境大病患儿及孤儿21,379人，并为35,803人次的患儿、家人以及医护人员提供人文关怀服务。
                            </p>
                        </div>
                    </div>
                </li>
                <li class="item">
                    <h3>灾害救援</h3>
                    <div class="link">
                        <div class="mask"><img class="forest-img" src="@/assets/images/sustainable/partnership/sf-item-05.png" alt="灾害救援" /></div>
                        <div class="detail-wrap">
                            <p class="desc">
                                面对突发重大社会灾害，顺丰不遗余力，倾力奉献，用实际行动向社会传递善意与爱心。2008至2023年，累计投入约1.47亿元用于社会灾害救援。
                                <br />
                                2008年，捐赠1,000万元支持汶川地震救灾；<br />
                                2010年，捐赠500万元用于西南旱灾救助；顺丰专机参与青海玉树震灾救援；<br />
                                2013年，参与雅安、岷县地震赈灾，为社会各地赈灾物资免除运费2,700万元； <br />2014年，参与鲁甸地震救灾；<br />
                                2015年，顺丰专机支援尼泊尔地震救灾，运送救灾物资约82吨；<br />
                                2020年，支持新冠疫情救援，累计支出5,257万元；<br />
                                2021年，捐赠2,000万元支持河南防汛救灾及灾后重建；<br />
                                2022年，支持新冠疫情防控、参与四川甘孜州泸定地震救援、湖南双郫县泷泊镇上双村火灾救援等，累计支出577万元；<br/>
                                2023年，捐赠1,000万元支持河北京津冀防汛救灾及灾后重建，参与云南保山地震救灾、甘肃积石山地震救灾。<br/>
                            </p>
                        </div>
                    </div>
                </li>
                <li class="item item-relief">
                    <h3>乡村振兴</h3>
                    <div class="link">
                        <div class="mask"><img src="@/assets/images/sustainable/partnership/sf-item-06.png" alt="乡村振兴" /></div>
                        <div class="detail-wrap">
                            <p class="desc">
                                顺丰积极响应国家乡村振兴、共同富裕的战略。作为国内领先的综合性物流服务提供商，始终以“与时间赛跑”核心理念，深耕农产品寄递领域。无数顺丰小哥驻扎在原产地最初一公里，助力实现农产品从“田间”到“舌尖”的商业模式，赢得了广大消费者的信赖和好评。
                                <br />
                                顺丰助力农产品产销的服务网络已覆盖全国2,700多个县区级城市，囊括全国226类累计6,000多种特色农产品，2023年实现特色农产品运送约458万吨。顺丰以实际行动为乡村振兴贡献顺丰力量，让更多地方品牌的特色农产品被国人所知晓、品尝、认可。
                            </p>
                        </div>
                    </div>
                </li>
                <li class="item">
                    <h3>志愿者文化推动</h3>
                    <div class="link">
                        <div class="mask"><img src="@/assets/images/sustainable/partnership/sf-item-04.png" alt="志愿者文化推动" /></div>
                        <div class="detail-wrap">
                            <p class="desc">
                                2022年，顺丰公益基金会全年公益总支出11,740万元。<br />
                                22个志愿者协会组织开展公益活动148场次，活动参与7,226人次，志愿服务时长1,206,286小时。
                            </p>
                        </div>
                    </div>
                </li>
                <li class="item item-article expand">
                    <div class="link">
                        <div class="mask bg-blue bottom-gradient"></div>
                        <div class="detail-wrap">
                            <h4 class="title">暖心能量包，为困境患儿加持能量，传递温暖</h4>
                            <p class="desc">
                                <span
                                    >暖心能量包是顺丰公益基金会基于顺丰暖心项目服务理念开发的一款人文关怀公益产品，旨在以暖心能量包为载体，为困境患儿提供更有温度、更加多元的关怀和陪伴。
                                    2022年，顺丰公益基金会与某知名校服品牌联合推出新年定制版暖心能量包，为困境患儿提供儿童新衣、暖心纪念册。项目采取家长自愿申请的方式，共为山西、河北、湖南等地救助的309位“暖心小勇士”送上新年版暖心能量包，获得定点医院和患儿家长的一致好评。
                                </span>
                            </p>
                            <img class="img" src="@/assets/images/sustainable/community/enenery.jpg" />
                            <p class="desc">
                                <span
                                    >正值2022年新春，顺丰开展了暖心能量包项目，让仍然与病魔小怪兽斗争的孩子们实现“新年穿新衣”的愿望。当看到孩子们那一张张笑脸，以及家长们反馈的一段段感谢文字时，我的内心充满成就感。我们希望这些孩子在与病魔抗争的同时，也知道有很多人一直在陪伴和守护着他们，我希望他们以后能健康长大，长大后成为一个向上向善的美好青年。
                                </span>

                                <span class="fr">———顺丰暖心志愿者 </span>
                            </p>
                        </div>
                    </div>
                </li>
                <li class="item item-article">
                    <div class="link">
                        <div class="mask bg-blue bottom-gradient"></div>
                        <div class="detail-wrap">
                            <img class="img" src="@/assets/images/sustainable/community/sfnuanxin.jpg" />
                            <p class="desc">
                                <span
                                    >虽说孩子很不幸有先心病，但是从开始的心情沉重，到后来顺丰公益的大力资助，让先心病儿童的家长在绝望中看到了曙光，重新对生活有了信心。对于一个普通家庭来说，顺丰公益的爱心善举真的是雪中送炭。孩子术后恢复的很好，收到暖心能量包也非常开心。
                                </span>
                                <span class="fr">———患儿家长 </span>
                            </p>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="download">
                <a class="link" href="https://www.sf-express.com/uploads/2022_8a7477b59e.pdf" target="_blank">
                    <img src="@/assets/images/sustainable/download-icon.png" alt="下载《顺丰控股2022年可持续发展报告》" />
                    <p>下载《顺丰控股2022年度可持续发展报告》</p>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SustainablePartnership',
    data() {
        return {
            expandRecordOne: false,
            expandRecordTwo: false
        }
    }
}
</script>

<style lang="scss" scoped>
@import './common.scss';
.partnership-page {
    background: #e8e8e8;
    .banner {
        h3 {
            font-weight: 500;
        }
        .desc {
            text-align: justify;
        }
    }
    .main-content {
        padding: 0.72rem;
        font-size: 0.3rem;
        line-height: 1.8;
        text-align: left;
        color: #000000;
        background-color: #e8e8e8;
        .data-list {
            .title {
                color: #3c7c8c;
            }
            .remark {
                height: 0.44rem;
                line-height: 1.4;
                color: #000;
            }
        }
        .content-list {
            .item {
                margin-bottom: 1.28rem;
                & > h3 {
                    margin-bottom: 0.4rem;
                }
                .title {
                    height: 0.72rem;
                    font-size: 0.44rem;
                    line-height: 2.76;
                }
                .desc {
                    font-size: 0.3rem;
                    line-height: 1.4;
                }
                .forest-img {
                    min-height: 6.5rem;
                    background: transparent;
                }
                .detail-wrap {
                    padding: 0.32rem 0.44rem;
                    overflow: auto;
                    .desc {
                        margin-top: 0.2rem;
                        overflow-y: auto;
                        text-align: justify;
                    }
                }
                &.item-help {
                    .card {
                        background: #fff;
                        .card-header {
                            text-align: center;
                        }
                        .detail-wrap {
                            .title {
                                position: absolute;
                                top: -0.1rem;
                                font-size: 0.3rem;
                                color: #000;
                            }
                        }
                    }
                }
                &.item-article {
                    background: #80b0c4;
                    padding: 0.6rem 0.5rem;
                    .mask {
                        height: 8rem;
                        &:before {
                            opacity: 0;
                        }
                    }
                    &.expand {
                        .mask {
                            transition: height 0.3s ease-in-out;
                            min-height: 16.8rem;
                            &:nth-last-child(-1) {
                                min-height: 6.8rem;
                            }
                        }
                        .icon-caret:before {
                            transform: rotate(-45deg);
                        }
                        .img {
                            width: 100%;
                            margin-top: 10px;
                        }
                        .fr {
                            float: right;
                        }
                    }
                    .detail-wrap {
                        display: flex;
                        flex-direction: column;
                        padding: 0;
                        padding-bottom: 0.4rem;
                        .title {
                            height: auto;
                            line-height: initial;
                        }
                        .desc {
                            flex: 1;
                            overflow: hidden;
                            text-align: justify;
                            span {
                                display: inline-block;
                                margin-top: 0.2rem;
                            }
                        }
                    }
                }
            }
            .card {
                .card-header {
                    background: #80b0c4;
                    .detail-wrap {
                        position: relative;
                    }

                    .desc {
                        text-align: left;
                        text-align: justify;
                    }
                }
            }
        }
    }
    .icon-caret {
        position: relative;
        display: block;
        margin: 0 auto;
        width: 0.24rem;
        height: 0.24rem;
        &:before {
            position: absolute;
            content: '';
            width: 100%;
            height: 100%;
            left: calc(50% - 0.24rem);
            bottom: -0.12rem;
            border: solid 0.03rem;
            border-color: #fff #fff transparent transparent;
            transform: rotate(135deg);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/sustainable/community.vue